import { styled } from "@mui/material/styles";
import { Stack, useTheme, useMediaQuery, Typography } from "@mui/material";
import { useShow } from "hooks/useShow";
import Grid from "@mui/material/Unstable_Grid2";
import ngc from "assets/images/home/ngc.png";
import bai from "assets/images/home/bai.png";
import gen from "assets/images/home/gen.png";
import uob from "assets/images/home/uob.png";
import jen from "assets/images/home/jeneration.png";
import dra from "assets/images/home/drag.png";
import Transitions from "components/Transitions";

const BackedByBox = styled(Stack)`
  /* position: relative; */
  /* margin-top: 90px; */
`;

const Head = styled(Typography)`
  color: #fff;
  font-size: 42px;
  font-weight: 500;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      fontSize: "24px",
    },
  })};
`;

const Containter = styled(Stack)`
  height: 100%;
  width: 1200px;
  padding: 15px 25px 120px;
  box-sizing: border-box;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      width: "100%",
      padding: "0px 20px 60px",
    },
  })};
`;

const GridItem = styled(Stack)`
  aspect-ratio: 1 / 1;
  border-radius: 10px;
  background: #1a1a1a;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.12);
  &:hover {
    background: linear-gradient(180deg, #1f7a55 0%, #1c332a 100%);
    background-blend-mode: color-dodge, normal;
    box-shadow: 0px 1px 0px 0px rgba(255, 255, 255, 0.25) inset,
      -1px -1px 0px 0px rgba(0, 0, 0, 0.25) inset;
  }
`;

const ByImg = styled("img")`
  height: auto;
`;

const BackedBy = () => {
  const theme = useTheme();
  const upToMd = useMediaQuery(theme.breakpoints.up("md"));
  const { ref, isShow } = useShow();
  const byList = [
    {
      url: ngc,
      width: 104,
      widthM: 56,
    },
    {
      url: bai,
      width: 113,
      widthM: 61,
    },
    {
      url: gen,
      width: 109,
      widthM: 59,
    },
    {
      url: uob,
      width: 141,
      widthM: 77,
    },
    {
      url: jen,
      width: 88,
      widthM: 48,
    },
    {
      url: dra,
      width: 136,
      widthM: 74,
    },
  ];

  return (
    <BackedByBox justifyContent="center" alignItems="center" direction="row">
      <Containter>
        <Transitions delay={200} isShow={isShow}>
          <Head>Backed by</Head>
        </Transitions>
        <Transitions delay={400} isShow={isShow}>
          <Stack ref={ref} mt={20}>
            <Grid container spacing={10}>
              {byList.map((item, index) => (
                <Grid key={index} xs={4} md={2}>
                  <GridItem
                    justifyContent="center"
                    alignItems="center"
                    direction="row"
                    width={"100%"}
                    height={"100%"}
                  >
                    <ByImg
                      style={{
                        width: `${upToMd ? item.width : item.widthM}px`,
                      }}
                      src={item?.url}
                    />
                  </GridItem>
                </Grid>
              ))}
            </Grid>
          </Stack>
        </Transitions>
      </Containter>
    </BackedByBox>
  );
};

export default BackedBy;
